import { UserSettings } from '@griply/types';
import { useMutation } from '@tanstack/react-query';
import { updateUserSettings } from 'shared/services/backend-api';

export const useUpdateUserSettingsMutation = () =>
  useMutation({
    mutationFn: async (settings: Partial<UserSettings>) =>
      updateUserSettings(settings),
  });
